export const CHECKOUT_ADDRESS_ENTERED = 'address-entered';
// TODO: export const CHECKOUT_ADDRESS_RECOMMENDED = 'address-recommended';
export const GOOGLE_ADDRESS_VALIDATION_FIELD_CONFIRMED = 'CONFIRMED';
